import { useMediaQuery, useTheme } from "@mui/material";

export default function ThingsToDo() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        margin: "1rem",
      }}
    >
      {/* Assiniboine Park Zoo */}
      <div
        style={{
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          justifyContent: "space-evenly",
          borderBottom: "1px solid black",
          paddingBottom: "1rem",
        }}
      >
        <img
          src={"img/things-to-do/assiniboine-park-zoo.jpg"}
          alt="Assiniboine Park Zoo"
          style={{ width: isMobile ? "100%" : "33%" }}
        />
        <div style={{ width: isMobile ? "100%" : "50%" }}>
          <h1>Assiniboine Park Zoo</h1>
          <a href="https://www.assiniboinepark.ca/zoo/visit/hours-and-rates">
            https://www.assiniboinepark.ca/zoo/visit/hours-and-rates
          </a>
          <ul style={{ paddingLeft: "1rem" }}>
            <li>
              Award winning zoo for its Journey to Churchill exhibit which
              includes all northern animals who have been orphaned from northern
              Canada – including 9 polar bears from Churchill.
            </li>
            <li>There is an admission cost.</li>
            <li>Free parking.</li>
            <li>Restaurants on site.</li>
            <li>Accessible to all.</li>
            <li>Can reach the entrance by city bus.</li>
          </ul>
        </div>
      </div>
      {/* Manitoba Museum */}
      <div
        style={{
          display: "flex",
          flexDirection: isMobile ? "column" : "row-reverse",
          justifyContent: "space-evenly",
          borderBottom: "1px solid black",
          paddingTop: "1rem",
          paddingBottom: "1rem",
        }}
      >
        <img
          src={"img/things-to-do/manitoba-museum.jpg"}
          alt="Manitoba Museum"
          style={{ width: isMobile ? "100%" : "33%" }}
        />
        <div style={{ width: isMobile ? "100%" : "50%" }}>
          <h1>Manitoba Museum</h1>
          <a href="https://manitobamuseum.ca/ ">https://manitobamuseum.ca/</a>
          <ul style={{ paddingLeft: "1rem" }}>
            <li>
              Great interactive museum for all ages on the history of Manitoba.
            </li>
            <li>Can be reached by city bus.</li>
            <li>There is an admission fee.</li>
          </ul>
        </div>
      </div>
      {/* Royal Aviation Museum of Western Canada */}
      <div
        style={{
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          justifyContent: "space-evenly",
          borderBottom: "1px solid black",
          paddingTop: "1rem",
          paddingBottom: "1rem",
        }}
      >
        <img
          src={"img/things-to-do/royal-aviation-museum-of-western-canada.jpg"}
          alt="Royal Aviation Museum of Western Canada"
          style={{ width: isMobile ? "100%" : "33%" }}
        />
        <div style={{ width: isMobile ? "100%" : "50%" }}>
          <h1>Royal Aviation Museum of Western Canada</h1>
          <a href="https://royalaviationmuseum.com/ ">
            https://royalaviationmuseum.com/
          </a>
          <ul style={{ paddingLeft: "1rem" }}>
            <li>
              Great museum for all ages on the history of aviation in Manitoba
              with specific section on the bush pilots, fantastic display of 22
              aircraft through the ages.
            </li>
            <li>Located right beside the airport.</li>
            <li>Can be reached by city bus.</li>
            <li>There is an admission fee.</li>
            <li>
              There is a parking fee; however, once you buy an admission ticket
              parking will be free.
            </li>
          </ul>
        </div>
      </div>
      {/* Leo Mol Scultpure Garden */}
      <div
        style={{
          display: "flex",
          flexDirection: isMobile ? "column" : "row-reverse",
          justifyContent: "space-evenly",
          borderBottom: "1px solid black",
          paddingTop: "1rem",
          paddingBottom: "1rem",
        }}
      >
        <img
          src={"img/things-to-do/leo-mol-sculpture-garden.jpg"}
          alt="Leo Mol Sculpture Garden"
          style={{ width: isMobile ? "100%" : "33%" }}
        />
        <div style={{ width: isMobile ? "100%" : "50%" }}>
          <h1>Leo Mol Sculpture Garden</h1>
          <a href="https://www.assiniboinepark.ca/park/gardens/leo-mol-sculpture-garden ">
            https://www.assiniboinepark.ca/park/gardens/leo-mol-sculpture-garden{" "}
          </a>
          <ul style={{ paddingLeft: "1rem" }}>
            <li>Amazing sculptures garden.</li>
            <li>Accessible for those with mobility issues.</li>
            <li>Free parking right beside the garden.</li>
            <li>Located in Charleswood.</li>
            <li>
              Can be reached by city bus; however, you'll need to walk approx
              10-15 min from where the bus will drop you off.
            </li>
            <li>Free.</li>
          </ul>
        </div>
      </div>
      {/* The Leaf */}
      <div
        style={{
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          justifyContent: "space-evenly",
          borderBottom: "1px solid black",
          paddingTop: "1rem",
          paddingBottom: "1rem",
        }}
      >
        <img
          src={"img/things-to-do/the-leaf.jpg"}
          alt="The Leaf"
          style={{ width: isMobile ? "100%" : "33%" }}
        />
        <div style={{ width: isMobile ? "100%" : "50%" }}>
          <h1>The Leaf</h1>
          <a href="https://www.assiniboinepark.ca/leaf/lifegrows ">
            https://www.assiniboinepark.ca/leaf/lifegrows
          </a>
          <ul style={{ paddingLeft: "1rem" }}>
            <li>
              Spectacular horticultural exhibit in an amazing architectural
              building with a story.
            </li>
            <li>The inside exhibit has an admission fee.</li>
            <li>
              The outside gardens are free and include a beautiful totem pole on
              loan from the Southern Chiefs in commemoration of the residential
              school students.
            </li>
          </ul>
        </div>
      </div>
      {/* The Forks */}
      <div
        style={{
          display: "flex",
          flexDirection: isMobile ? "column" : "row-reverse",
          justifyContent: "space-evenly",
          borderBottom: "1px solid black",
          paddingTop: "1rem",
          paddingBottom: "1rem",
        }}
      >
        <img
          src={"img/things-to-do/the-forks.jpg"}
          alt="The Forks"
          style={{ width: isMobile ? "100%" : "33%" }}
        />
        <div style={{ width: isMobile ? "100%" : "50%" }}>
          <h1>The Forks</h1>
          <a href="https://www.theforks.com/">https://www.theforks.com/ </a>
          <ul style={{ paddingLeft: "1rem" }}>
            <li>
              The Forks is aptly named for where the Assiniboine and the Red
              Rivers join.
            </li>
            <li>Great spot to walk and read the history of the area.</li>
            <li>Great shops and restaurants.</li>
            <li>No admission fee.</li>
          </ul>
        </div>
      </div>
      {/* Canadian Museum for Human Rights */}
      <div
        style={{
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          justifyContent: "space-evenly",
          borderBottom: "1px solid black",
          paddingTop: "1rem",
          paddingBottom: "1rem",
        }}
      >
        <img
          src={"img/things-to-do/canadian-museum-for-human-rights.jpg"}
          alt="Canadian Museum for Human Rights"
          style={{ width: isMobile ? "100%" : "33%" }}
        />
        <div style={{ width: isMobile ? "100%" : "50%" }}>
          <h1>Canadian Museum for Human Rights</h1>
          <a href="https://humanrights.ca/ ">https://humanrights.ca/</a>
          <ul style={{ paddingLeft: "1rem" }}>
            <li>
              Great exhibits and fantastic building architecture with a story.
            </li>
            <li>Located in downtown Winnipeg at The Forks.</li>
            <li>Can be reached by city bus.</li>
            <li>There is an admission fee.</li>
          </ul>
        </div>
      </div>
      {/* Royal Canadian Mint */}
      <div
        style={{
          display: "flex",
          flexDirection: isMobile ? "column" : "row-reverse",
          justifyContent: "space-evenly",
          borderBottom: "1px solid black",
          paddingTop: "1rem",
          paddingBottom: "1rem",
        }}
      >
        <img
          src={"img/things-to-do/royal-canadian-mint.jpg"}
          alt="Royal Canadian Mint"
          style={{ width: isMobile ? "100%" : "33%" }}
        />
        <div style={{ width: isMobile ? "100%" : "50%" }}>
          <h1>Royal Canadian Mint</h1>
          <a href="https://www.mint.ca/en/visit-the-mint/winnipeg-mint?rcmeid=Google_MyBusiness_Winnipeg">
            https://www.mint.ca/en/visit-the-mint/winnipeg-mint?rcmeid=Google_MyBusiness_Winnipeg
          </a>
          <ul style={{ paddingLeft: "1rem" }}>
            <li>This mint produces coins from all around the world.</li>
            <li>The 45 minute tour of the facility has an admission charge.</li>
            <li>The gift shop and gold bar display are free.</li>
            <li>Free parking.</li>
            <li>Requires a car.</li>
          </ul>
        </div>
      </div>
      {/* Winnipeg Art Gallery */}
      <div
        style={{
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          justifyContent: "space-evenly",
          borderBottom: "1px solid black",
          paddingTop: "1rem",
          paddingBottom: "1rem",
        }}
      >
        <img
          src={"img/things-to-do/winnipeg-art-gallery.jpg"}
          alt="Winnipeg Art Gallery"
          style={{ width: isMobile ? "100%" : "33%" }}
        />
        <div style={{ width: isMobile ? "100%" : "50%" }}>
          <h1>Winnipeg Art Gallery</h1>
          <a href="https://www.wag.ca/">https://www.wag.ca/</a>
          <ul style={{ paddingLeft: "1rem" }}>
            <li>Located in downtown Winnipeg.</li>
            <li>Can be reached by city bus.</li>
            <li>
              On the street parking available – will require the paybyphone app
              as there are no longer any parking meters.
            </li>
            <li>There is an admission fee.</li>
          </ul>
        </div>
      </div>
      {/* Activate Winnipeg West */}
      <div
        style={{
          display: "flex",
          flexDirection: isMobile ? "column" : "row-reverse",
          justifyContent: "space-evenly",
          borderBottom: "1px solid black",
          paddingTop: "1rem",
          paddingBottom: "1rem",
        }}
      >
        <img
          src={"img/things-to-do/activate-winnipeg-west.webp"}
          alt="Activate Winnipeg West"
          style={{ width: isMobile ? "100%" : "33%" }}
        />
        <div style={{ width: isMobile ? "100%" : "50%" }}>
          <h1>Activate Winnipeg West</h1>
          <a href="https://playactivate.com/winnipeg-west">
            https://playactivate.com/winnipeg-west
          </a>
          <ul style={{ paddingLeft: "1rem" }}>
            <li>70 min of fun active challenges for groups of 2 or more.</li>
            <li>There's an admission fee.</li>
          </ul>
        </div>
      </div>
      {/* The Rec Room Winnipeg */}
      <div
        style={{
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          justifyContent: "space-evenly",
          paddingTop: "1rem",
        }}
      >
        <img
          src={"img/things-to-do/the-rec-room.webp"}
          alt="The Rec Room"
          style={{ width: isMobile ? "100%" : "33%" }}
        />
        <div style={{ width: isMobile ? "100%" : "50%" }}>
          <h1>The Rec Room</h1>
          <a href="https://www.therecroom.com/winnipeg-tuxedo">
            https://www.therecroom.com/winnipeg-tuxedo
          </a>
          <ul style={{ paddingLeft: "1rem" }}>
            <li>
              Right beside the Hyatt and walking distance from the Hilton.
            </li>
            <li>Offers arcade games, bowling, ax throwing.</li>
            <li>Full restaurant.</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
